<div class="section-shell">
  <button
    type="button"
    class="section-add"
    [disabled]="!openedCredit || !canAddPaymentPromises"
    matTooltip="Добави уговорка"
    aria-label="Добави уговорка"
    (click)="sectionPanel.open(); openCreatePromiseDialog()"
  >
    <mat-icon>add</mat-icon>
  </button>

  <mat-expansion-panel #sectionPanel class="section-panel mat-elevation-z0">
    <mat-expansion-panel-header collapsedHeight="44px" expandedHeight="44px">
      <mat-panel-title>
        Уговорки
        <span class="section-count">{{ paymentPromises?.length || 0 }}</span>
      </mat-panel-title>
    </mat-expansion-panel-header>

    <div class="promise-list">
      @for (promise of paymentPromises; track promise) {
        <div class="promise-row">
          <button
            type="button"
            class="promise-edit"
            [matTooltip]="
              promise.status | paymentPromiseStatusToTranslationKey | translate
            "
            matTooltipPosition="left"
            (click)="openPromiseEditDialog(promise)"
          >
            <mat-icon
              fontSet="material-symbols-outlined"
              class="status-icon"
              [style.color]="promiseStatusStyleMap[promise.status]?.color"
            >
              {{ promiseStatusStyleMap[promise.status]?.icon }}
            </mat-icon>

            <span>
              {{ promise.amount | toCustomItfgCurrency }} на
              {{ promise.date | date: 'dd.MM.yy' }}
            </span>
          </button>

          <button
            type="button"
            class="remove-button"
            matTooltip="Деактивирай уговорката"
            aria-label="Деактивирай уговорката"
            (click)="deactivatePromise(promise)"
          >
            <mat-icon>remove</mat-icon>
          </button>
        </div>
      }
    </div>
  </mat-expansion-panel>
</div>
